import React, { useState, CSSProperties, useEffect } from "react";
import BarLoader from "react-spinners/BarLoader";

import loadingSpinner from "../../assets/loadingSpinners/Loading_Spinner_TransparentBg_v01_75x75.gif";
export default function LoadingSpinner({ title, extraText, size, row }) {
  let [loading, setLoading] = useState(true);
  let [color, setColor] = useState("#13C56B");

  const [styleLogoSize, setStyleLogoSize] = useState({});
  const [styleHeaderH2, setStyleHeaderH2] = useState({});
  useEffect(() => {
    switch (size) {
      case "small":
        setStyleLogoSize({
          width: "50px",
          height: "50px",
        });
        setStyleHeaderH2({
          fontSize: "1rem",
        });
        break;

      case "medium":
        setStyleLogoSize({
          width: "100px",
          height: "100px",
        });
        setStyleHeaderH2({
          fontSize: "1.5rem",
        });
        break;

      case "large":
        setStyleLogoSize({
          width: "150px",
          height: "150px",
        });
        setStyleHeaderH2({
          fontSize: "2rem",
        });
        break;

      default:
        break;
    }
  }, [size]);
  return (
    <div
      className={`d-flex ${
        row ? " flex-row " : " flex-column "
      } align-items-center justify-content-center`}
    >
      <h2 style={styleHeaderH2}>{title ?? "Loading..."}</h2>
      <div className="sweet-loading">
        {extraText && <p className={"text-muted"}>{extraText}</p>}
        <div className={"w-100 d-flex justify-content-center"}>
          {/*<BarLoader*/}
          {/*  color={color}*/}
          {/*  loading={loading}*/}
          {/*  size={150}*/}
          {/*  aria-label="Loading Spinner"*/}
          {/*  data-testid="loader"*/}
          {/*/>*/}
          <img
            style={styleLogoSize}
            src={loadingSpinner}
            alt="Loading Spinner"
          />
        </div>
      </div>
    </div>
  );
}
